import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'nirby-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent {}
